// extracted by mini-css-extract-plugin
export default {"create-cards":"Create_create-cards__C+X1Q"};